import { Box, Typography } from "@mui/material";
import { Trans } from "@lingui/react/macro";

const InvalidGraph = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        backgroundColor: "#f9f9f9",
        border: "1px dashed #ccc",
      }}
      marginBottom={"4%"}
      height={300}
      width={700}
    >
      <Typography variant="h6" color="textSecondary">
        <Trans
          context={
            "Information shown to the user in case of erroneous graph generation."
          }
        >
          Graph data can't be loaded.
        </Trans>
      </Typography>
    </Box>
  );
};

export default InvalidGraph;
